<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCpcolonia" role="form" method="post" autocomplete="off" onSubmit="return false">	
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objCpColonia.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCpColonia.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="CodigoPostal">Codigo Postal</label>
							<input type="text" v-model="objCpColonia.CodigoPostal" class="form-control" id="CodigoPostal" placeholder="Ingresar Codigo Postal" />
							<CValidation v-if="this.errorvalidacion.CodigoPostal" :Mensaje="'*'+errorvalidacion.CodigoPostal[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="IdEstado">Estado</label>
							<select @change="SetIdEstado" v-model="IdEstado" class="form-control-search form-select" id="IdEstado">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in Estados" :key="index" :value="item.IdEstado">{{item.Clave + ' - '+ item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdEstado" :Mensaje="'*'+errorvalidacion.IdEstado[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="IdMunicipio">Municipio</label>
							<select v-model="objCpColonia.IdMunicipio" class="form-control-search form-select" id="IdMunicipio">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in Municipios" :key="index" :value="item.Clave">{{item.Clave + ' - '+ item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdMunicipio" :Mensaje="'*'+errorvalidacion.IdMunicipio[0]"/>
						</div>
					</div>
										
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCpcolonia',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpColonia: {
				IdColonia: 0,
				IdEstado: '',
				IdMunicipio: '',
				Clave: '',
				CodigoPostal: '',
				Nombre: '',
            },
			IdEstado:'',
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			Estados: [],
			Municipios: [],
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpColonia.IdColonia == 0) {
				await this.$http.post(
					'cpColonias',this.objCpColonia
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpColonias/'+this.objCpColonia.IdColonia,
					this.objCpColonia
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpColonias/"+this.objCpColonia.IdColonia
            ).then((res) => {
				let index=this.Estados.findIndex((Estado)=>Estado.Clave==res.data.data.IdEstado);
				this.IdEstado=this.Estados[index].IdEstado;
                this.objCpColonia = res.data.data;
				this.GetMunicipios();
				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpColonia.Fecha.replace(/-/g,'\/');
                this.objCpColonia.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCpColonia = {
				IdColonia: 0,
				IdEstado: '',
				IdMunicipio: '',
				Clave: '',
				CodigoPostal: '',
				Nombre: '',
            }
            this.errorvalidacion = [];
			this.IdEstado='';
        },
		GetEstados()
		{
			this.$http.get("cpEstados", {
				params:{
					simple: 1,
				}
			}).then((res) => {
				this.Estados = res.data.data;
			});
		},
		GetMunicipios()
		{
			this.$http.get("cpMunicipios", {
				params:{
					IdEstado:this.IdEstado,
					simple: 1,
				}
			}).then((res) => {
				this.Municipios = res.data.data;
			});
		},
		SetIdEstado(){
			this.objCpColonia.IdMunicipio='';
			if (this.IdEstado!='') {
				let index=this.Estados.findIndex((Estado)=>Estado.IdEstado==this.IdEstado);
				this.objCpColonia.IdEstado=this.Estados[index].Clave;
				this.GetMunicipios();
			}
			else{
				this.Municipios=[];
			}
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

			this.GetEstados();

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpColonia.IdColonia = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    },
	// computed: {
	// 	Municipios:(()=>{
	// 		if (this.Estad) {
				
	// 		}
	// 	})
	// },
}
</script>
